import { createFileRoute } from '@tanstack/react-router'
import { CustomerCdrsPage } from '@/features/customer/pages/cdrs'

export const Route = createFileRoute('/_authenticated/customer/cdrs')({
  component: CustomerCdrsPage,
})
